module.exports = __webpack_public_path__ + "static/media/logo-cdatribe.78252540.png";